import React from 'react';
import PropTypes from 'prop-types';
import { Info } from '@phosphor-icons/react';

const InfoCard = (props) => {
  const {
    icon,
    content,
    type,
    className,
  } = props;

  return (
    <div className={`info-card-wrapper bg-grey-5 rounded-xl px-6 py-5 flex items-center justify-start w-full gap-5 ${type} ${className}`}>
      <div className="icon p-1.5">
        {icon}
      </div>
      <div className="info text-16 black">
        {content}
      </div>
    </div>
  );
};

InfoCard.propTypes = {
  icon: PropTypes.node,
  content: PropTypes.node,
  type: PropTypes.string,
  className: PropTypes.string,
};

InfoCard.defaultProps = {
  icon: <Info size={24}
    color="#101010" />,
  content: null,
  type: 'default',
  className: '',
};

export default InfoCard;
